import { render } from "./FormGroupV2.vue?vue&type=template&id=0e01868a&ts=true"
import script from "./FormGroupV2.vue?vue&type=script&lang=ts"
export * from "./FormGroupV2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__